export default __webpack_public_path__ + "static/media/2017 LV BOOTH EXPLANATION-07.6243d6fc.jpg";